import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import Alert from '~/commons/components/Alert.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import { numToLetter } from '~/commons/helpers';
import { env } from '~/commons/config';
import FieldsQtnOpts from './FieldsQtnOpts.jsx';

export const defaultQtn = () => ({
  format: 'single-select',
  question: '',
  sentenceTemplate: '',
  img: null,
  choices: [],
  matches: [],
  answer: null,
  answers: [],
});
export const defaultQtnSet = (i) => ({
  refCode: numToLetter(i).toUpperCase(),
  draw: 0,
  challenge: false,
  questions: [defaultQtn()],
});

const FieldsCompQtnSet = ({ fileUploadUrl, answered, idx }) => (
  <div className="pt-3">
    {answered && (
      <Alert theme="warning">
        Some of the users have already answered these questions. Only limited
        changes can be made.
      </Alert>
    )}
    <FormGroup
      name={`questionSets[${idx}].refCode`}
      label="Subject / Reference Code"
      required
    />
    <FormGroup
      name={`questionSets[${idx}].draw`}
      type="number"
      label="No. of draw"
      helpText="How many questions will be picked randomly from this question bank"
      required
    />
    <FormCheckGroup
      name={`questionSets[${idx}].challenge`}
      type="checkbox"
      label="Challenge Mode (for this question bank)"
      helpText="Enable challenge mode for this question bank."
    />
    <label>Questions</label>
    <FieldArrayIterables
      name={`questionSets[${idx}].questions`}
      {...(answered
        ? {}
        : {
          push: defaultQtn,
        })}
    >
      {(q, i, { remove }) => (
        <div key={i} className="card mb-3">
          {!answered && (
            <button className="btn btn-link close" onClick={() => remove(i)}>
              <FA icon={faTimes} size="sm" />
            </button>
          )}
          <div className="card-body">
            <div className="row">
              <div className="col">
                <FormGroup
                  as="textarea"
                  name={`questionSets[${idx}].questions.${i}.question`}
                  label={`${i + 1}. Question`}
                  rows={6}
                  required
                />
                {env.config.ARTICLE_FORMAT_ENABLE && (
                  <FormGroup
                    as="select"
                    name={`questionSets[${idx}].questions.${i}.format`}
                    label="Format"
                  >
                    <option value="single-select">單選</option>
                    <option value="multi-select">多選</option>
                    <option value="ordering">排序</option>
                    <option value="matching">配對</option>
                    <option value="image-dragdrop">圖片拖放</option>
                    <option value="sentence-completion">詩詞重組</option>
                    <option value='idiom-fill'>成語填空</option>
                  </FormGroup>
                )}

                {/* <label>Choices *</label>
                <FieldArrayIterables
                  name={`questionSets[${idx}].questions.${i}.choices`}
                  {...answered ? {} : {
                    tail: '',
                  }}
                >
                  {(c, ii) => (
                    <div
                      className="form-row align-items-center"
                      key={ii}
                    >
                      <div className="col-auto pb-3">
                        {numToLetter(ii, true)}.
                      </div>
                      <div className="col">
                        <FormGroup
                          radio={{
                            name: `questionSets[${idx}].questions.${i}.answer`,
                            value: ii.toString(),
                          }}
                          name={
                            `questionSets[${idx}].questions.${i}.choices.${ii}`
                          }
                          label={null}
                        />
                      </div>
                    </div>
                  )}
                </FieldArrayIterables> */}
              </div>
              <div className="col">
                <FormGroup
                  className="contain"
                  name={`questionSets[${idx}].questions.${i}.img`}
                  as="coverImgVideo"
                  label="Image (suggested dimension: 1280 x 960px) / Video (mg4)"
                  api={fileUploadUrl}
                />
              </div>
            </div>
            <FieldsQtnOpts
              idx={idx}
              qtnIndex={i}
              restrictEdit={answered}
              fileUploadUrl={fileUploadUrl}
            />
          </div>
        </div>
      )}
    </FieldArrayIterables>
  </div>
);

export default FieldsCompQtnSet;
